import { GridSortModel } from '@mui/x-data-grid';
import { isEmpty } from 'lodash-es';
import { useCallback, useState, useEffect } from 'react';
import { CrmJobFilterDTO, getAllCrmJobs } from 'wisestep-api';

import { CrmJobListingResponse } from '../helper/crmJobHelper';

export const useCrmJobs = (
  searchQuery: CrmJobFilterDTO,
  sortModel: GridSortModel,
  pageNo = 0,
  pageSize = 50
) => {
  const [jobs, setJobs] = useState<CrmJobListingResponse>();
  const [loading, setLoading] = useState<boolean>(false);

  const fetchCrmJobs = useCallback(async () => {
    setLoading(true);
    try {
      const [sortBy, sortOrder] = !isEmpty(sortModel)
        ? [sortModel[0].field, sortModel[0].sort ?? 'desc']
        : [undefined, 'desc'];

      const crmJobsData = await getAllCrmJobs({
        ...searchQuery,
        sortBy,
        sortOrder,
        page: pageNo,
        size: pageSize,
      });

      setJobs(crmJobsData?.data || null);
    } catch (error) {
      console.error('Error fetching CRM jobs:', error);
    } finally {
      setLoading(false);
    }
  }, [searchQuery, sortModel, pageNo, pageSize]);

  useEffect(() => {
    fetchCrmJobs();
  }, [fetchCrmJobs]);

  return {
    jobs,
    loading,
    fetchCrmJobs,
    setJobs,
  };
};
